export const PharmaciesApiUrls = {
  pharmacies: '/medical-orders/pharmacies',
};
